import MdIcon from './md-icon.vue';

export default MdIcon;
